module.exports = __webpack_public_path__ + "img/04-sm.e4651a8.webp";